import {styled} from "@mui/material/styles";
import {List, ListItem, ListItemButton} from "@mui/material";

export const ListWrapper = styled(List)(
	({ theme }) => `
		
	`
);

export const ListItemWrapper = styled(ListItem)(
	({ theme }) => `
		&:first-of-type {
			padding-top: 4px;
		}
		// &:first-child { 
		// 	padding-top: 4px;
		// }			
		// &:last-child {
		// 	margin-bottom: 2px;
		// }
		padding: 2px;
`
);

export const ListItemButtonWrapper = styled(ListItemButton)(
	({ theme, active, height }) => `	
	background-color: ${active === "true" ? "#c1d6f4" : "#ffffff"};
	border: ${active === "true" ? "1px solid #3c82f7" : "1px solid #c7c7c7"};	
	height: ${height}px;	
`
);
